<template>
  <div>
    <el-table :data="records">
      <el-table-column prop="id" label="账号"></el-table-column>
      <el-table-column prop="type" label="币种"></el-table-column>
      <el-table-column prop="hashCode" label="地址" min-width="200"></el-table-column>
      <el-table-column prop="createTime" label="时间">
        <template slot-scope="scope">
          {{scope.row.createdTime | moment}}
        </template>
      </el-table-column>
      <el-table-column prop="__status" label="状态">
        <template slot-scope="scope">
          <el-tag 
            :type="scope.row.__status.color" 
            v-if="scope.row.status !== 2"
          >
            {{scope.row.__status.text}}
          </el-tag>
          <span 
            v-if="scope.row.status === 2" 
            class="text-disabled"
          >
            {{scope.row__status.text}}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="number" label="数量" ></el-table-column>
    </el-table>
    <pagination
        :size="pagination.size"
        :page="pagination.page"
        :total="totalCount"
        @pageChanged="handleCurrentChange"
        >
      </pagination>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import Pagination from 'components/pagination';

export default {
  name: 'records',
  computed: {
    ...mapState('txRecord', ['totalCount', 'pagination']),
    ...mapGetters('txRecord', ['records'])
  },
  components: {
    Pagination
  },
  methods: {
    handleCurrentChange(pagination) {
      this.$emit('refresh', pagination);
    }
  }
};
</script>
